export class CountryLevelValidations {
    public static validations = {
        'firstName': {
            'minLength': 1,
            'maxLength': 20,
            'pattern': '^[a-zA-Z0-9 -]+$'
        },
        'middleName': {
            'minLength': 1,
            'maxLength': 5,
            'pattern': '^[a-zA-Z0-9 -]+$'
        },
        'lastName': {
            'minLength': 1,
            'maxLength': 25,
            'pattern': '^[a-zA-Z0-9 -]+$'
        },
        'phoneNumber': {
            'minLength': 10,
            'maxLength': 15,
            "required": true
            
        },
        'pass_word': {
            'minLength': 8,
            'maxLength': 30
        },
        'email': {
            'maxLength': 50
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/customerservice/constants/country-level-validations.interface.ts